import { Box } from "@components/Box"
import { Text } from "@components/ui/typograhpy/Text"
import { cn } from "@lib/cn"
import { parseError } from "@lib/parse-error"
import { NewUploadTask } from "@lib/store/uploads"
import { fileToThumbnail } from "@lib/store/utils"
import NextImage from "next/image"
import React, { FC, useEffect, useState } from "react"
import { NoImage } from "./NoImage"
import { UploadStatusIndicator } from "./UploadStatusIndicator"

export const ListItemUpload: FC<NewUploadTask> = ({
  status,
  errorCode,
  uploadProgress,
  file,
}: NewUploadTask) => {
  const [thumbnail, setThumbnail] = useState<string | null>(null)
  useEffect(() => {
    async function createThumbnail() {
      setThumbnail(await fileToThumbnail(file))
    }
    if (file) {
      createThumbnail()
    }
  }, [file])
  return (
    <li className="mb-5 grid grid-cols-[40px_auto_7rem] items-center gap-x-4">
      {thumbnail ? (
        <div
          className={cn(
            "after:bg-background after:bg-opacity-40 relative h-10 w-10 overflow-hidden rounded-md after:absolute after:left-0 after:h-full after:w-full after:content-['']",
            "data-is-ready:after:opacity-0",
          )}
          data-is-ready={status === "finished" ? "" : undefined}
        >
          <NextImage
            src={thumbnail}
            alt=""
            width={40}
            height={40}
            objectFit="cover"
            objectPosition="cover"
          />
        </div>
      ) : (
        <NoImage />
      )}
      <div className="w-full overflow-hidden">
        <Text
          variant="regular"
          className="mb-0 w-full overflow-hidden whitespace-nowrap text-white"
        >
          {file.name}
        </Text>
        {status === "error" ? (
          <Text variant="small" className="text-danger">
            {parseError(errorCode)}
          </Text>
        ) : (
          <Text variant="micro" className="text-grey">
            Upload
          </Text>
        )}
      </div>
      <Box className="mr-2 flex justify-end">
        <UploadStatusIndicator
          status={status}
          uploadProgress={uploadProgress}
        />
      </Box>
    </li>
  )
}
